export function formatKnowledgeRate(rate: number | null | undefined) {
  if (rate == null) return "—"
  return `${rate.toFixed(1)}%`
}
